import { Pipe, PipeTransform } from '@angular/core';

const COLORS = [
  'var(--nui-fill-categories-green-bold, var(--ui-color-additional-salmon))',
  'var(--nui-fill-categories-indigo-bold, var(--ui-color-additional-aqua))',
  'var(--nui-fill-categories-orange-bold, var(--ui-color-additional-sky))',
  'var(--nui-fill-categories-pink-bold, var(--ui-color-additional-purple))',
  'var(--nui-fill-categories-teal-bold, var(--ui-color-additional-coral))',
  'var(--nui-fill-categories-tomato-bold, var(--ui-color-additional-olive))'
];

@Pipe({
  name: 'nsAvatarColor'
})
export class AvatarColorPipe implements PipeTransform {
  transform(id: string): string {
    if (id === 'SYSTEM') {
      return 'transparent';
    }

    return COLORS[(COLORS.length * Math.random()) | 0];
  }
}
